import React from 'react';
import { bool, func, string } from 'prop-types';

// Components
import { Box, Button } from '@mui/material';

const buttonBoxContainerStyles = theme => ({
  alignItems: 'center',
  backgroundColor: theme.palette.surface.white,
  bottom: 0,
  boxShadow: theme.shadows[0],
  display: 'flex',
  height: 64,
  justifyContent: 'center',
  position: 'fixed',
  width: '100%',
  [theme.breakpoints.up('md')]: {
    backgroundColor: 'unset',
    boxShadow: 'unset',
    gridColumnStart: 3,
    gridRowStart: 2,
    height: 'unset',
    justifyContent: 'flex-end',
    paddingRight: theme.spacing(2),
    position: 'unset',
  },
});

const footerButtonStyles = {
  ':last-child': {
    marginLeft: theme => theme.spacing(3),
  },
  boxShadow: 'none',
  width: 104,
};

const NavigationButtons = props => {
  const { disabled, handleLeftButtonClick, leftLabel, handleRightButtonClick, rightLabel } = props;
  return (
    <Box sx={buttonBoxContainerStyles}>
      <>
        <Button onClick={handleLeftButtonClick} sx={footerButtonStyles} variant="outlined">
          {leftLabel}
        </Button>
        <Button disabled={disabled} onClick={handleRightButtonClick} sx={footerButtonStyles}>
          {rightLabel}
        </Button>
      </>
    </Box>
  );
};

NavigationButtons.propTypes = {
  disabled: bool.isRequired,
  handleLeftButtonClick: func.isRequired,
  handleRightButtonClick: func.isRequired,
  leftLabel: string.isRequired,
  rightLabel: string.isRequired,
};

export default NavigationButtons;
